import { render, staticRenderFns } from "./project-board.vue?vue&type=template&id=0d9024c8&"
import script from "./project-board.vue?vue&type=script&lang=ts&"
export * from "./project-board.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports